const road = "#3a3f4b";
const lot = "#1c2230";
const edge = "#8a93a6";
const text = { fill: "#9aa3b5", fontSize: 13, textAnchor: "middle" };

const Road = ({ x, y, w, h, label, vertical }) => (
  <g>
    <rect x={x} y={y} width={w} height={h} fill={road} />
    <text {...text} x={x + w / 2} y={y + h / 2 + 4} transform={vertical ? `rotate(-90 ${x + w / 2} ${y + h / 2})` : undefined}>{label}</text>
  </g>
);
const Lot = ({ points, label, lx, ly }) => (
  <g>
    <polygon points={points} fill={lot} stroke={edge} strokeWidth="2" strokeDasharray="6 4" />
    <text {...text} x={lx} y={ly}>{label}</text>
  </g>
);

export const PLAN_TEMPLATES = [
  { id: "rect_south", name: "整形地（南側道路）", svg: <><Lot points="60,30 340,30 340,240 60,240" label="敷地" lx={200} ly={140} /><Road x={0} y={252} w={400} h={48} label="道路（南）" /></> },
  { id: "corner", name: "角地（南・東道路）", svg: <><Lot points="40,30 320,30 320,240 40,240" label="敷地" lx={180} ly={140} /><Road x={0} y={252} w={400} h={48} label="道路（南）" /><Road x={332} y={0} w={68} h={252} label="道路（東）" vertical /></> },
  { id: "flag", name: "旗竿地", svg: <><Lot points="40,30 360,30 360,170 230,170 230,250 170,250 170,170 40,170" label="敷地" lx={200} ly={105} /><text {...text} x={200} y={215}>通路</text><Road x={0} y={258} w={400} h={42} label="道路" /></> },
  { id: "narrow", name: "細長い土地", svg: <><Lot points="150,20 250,20 250,248 150,248" label="敷地" lx={200} ly={140} /><Road x={0} y={256} w={400} h={44} label="道路" /></> },
  { id: "irregular", name: "不整形地・山林", svg: <><Lot points="60,60 180,25 330,50 365,160 300,245 120,250 40,170" label="敷地" lx={200} ly={145} /><path d="M0 275 C120 255 260 295 400 270 L400 300 L0 300 Z" fill={road} /><text {...text} x={200} y={292}>進入路</text></> },
  { id: "large", name: "大区画（造成・太陽光用地）", svg: <><Lot points="20,20 380,20 380,250 20,250" label="敷地" lx={200} ly={140} />{[0, 1, 2, 3].map((r) => <line key={r} x1="40" x2="360" y1={60 + r * 50} y2={60 + r * 50} stroke="#2a3142" strokeWidth="10" />)}<Road x={0} y={262} w={160} h={38} label="進入路" /></> },
];

export const NorthArrow = () => (
  <g transform="translate(372 30)" aria-label="北">
    <polygon points="0,-16 7,6 0,1 -7,6" fill="#d1d5db" />
    <text x="0" y="20" fill="#d1d5db" fontSize="11" textAnchor="middle">N</text>
  </g>
);
